<template>
<v-list class="pa-0">
  <v-list-tile v-for="item in items" :key="item.name" @click="item.click?item.click(data):null" :inactive="!item.click">
    <v-list-tile-action>
      <v-icon :color="isDisconnected ? 'grey' : item.colorIcon">{{ item.icon }}</v-icon>
    </v-list-tile-action>
    <v-list-tile-content>
      <v-list-tile-title>{{ item.displayValue }}</v-list-tile-title>
    </v-list-tile-content>
    <v-list-tile-action class="hidden-xs-only text-xs-right">
      <v-list-tile-sub-title>{{ $t(item.description) }}</v-list-tile-sub-title>
    </v-list-tile-action>
  </v-list-tile>
</v-list>
</template>

<script>
export default {
  name: 'GatewayDetailItemAttributes',
  props: ['data', 'isDisconnected', 'commands'],
  computed: {
    items() {
      return [{
        name: 'load',
        icon: 'favorite',
        description: 'gateway.load_average',
        colorIcon: 'red',
        displayValue: this.data.load ? this.data.load[1] : '---',
        click: (this.commands || {})['load']
      }, {
        name: 'free_memory',
        icon: 'data_usage',
        description: 'gateway.free_memory',
        colorIcon: 'brown',
        displayValue: this.data.ram ? ((this.data.ram.free / this.data.ram.total * 100).toFixed(1) + ' %') : '---',
        click: (this.commands || {})['free_memory']
      }, {
        name: 'latency',
        icon: 'network_check',
        description: 'gateway.latency',
        colorIcon: 'green',
        displayValue: this.data.latency ? `${this.data.latency} ${this.$t('gateway.milliseconds')}` : '---',
        click: (this.commands || {})['latency']
      }, {
        name: 'updated_time',
        icon: 'alarm',
        description: 'gateway.updated_time',
        colorIcon: 'indigo',
        displayValue: this.data.updatedTime ? new Date(this.data.updatedTime).toLocaleString() : '---',
        click: (this.commands || {})['updated_time']
      }, {
        name: 'location',
        icon: 'location_on',
        description: 'gateway.location',
        colorIcon: 'cyan',
        displayValue: this.data.map || '---',
        click: (this.commands || {})['location'] || (() => {
          if (this.data.map) window.open('https://www.google.com/maps/search/?api=1&query=' + this.data.map, "_blank");
        })
      }, {
        name: 'uuid',
        icon: 'link',
        description: 'gateway.uuid',
        colorIcon: 'teal',
        displayValue: this.data.uuid || '---',
        click: (this.commands || {})['uuid'] || (async () => {
          try {
            await this.$copyText(this.data.uuid);
            this.$emit('toast', this.$t('gateway.data_copied', {
              data: this.data.uuid
            }));
          } catch (err) {
            console.log(err);
          }
        })
      }, {
        name: 'ip_address',
        icon: 'network_wifi',
        description: 'gateway.ip_address',
        colorIcon: 'orange',
        displayValue: (this.data.address || '---').replace('::ffff:', '').split(':').find(m => m),
        click: (this.commands || {})['ip_address']
      }, {
        name: 'firmware',
        icon: 'developer_board',
        description: 'gateway.firmware',
        colorIcon: 'light-blue',
        displayValue: (this.data.firmware || {}).version ? `${(this.data.firmware || {}).version} @ ${(this.data.firmware || {}).time}` : '---',
        click: (this.commands || {})['firmware']
      }]
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/gateway/GatewayDetailItemAttributes.vue